module.exports = __webpack_public_path__ + "img/2.beb5d8e2.jpg";